import { Injectable } from '@angular/core';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";
import {Subject} from "rxjs/Subject";

@Injectable()
export class TestRackSetupService extends RestHttpService<any> {

  constructor(private service: Restangular) {
    super('test-rack-setups', service);
  }

  getPatchFieldLinks(testRackSetupService): Subject<any> {
    return super.getRawSubresource(testRackSetupService.id, 'patch-field-links');
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/test-rack/services/test-rack-setup.service.ts